<template>
    <bounce-spinner class="media-library__spinner"></bounce-spinner>
</template>

<script>
import BounceSpinner from "@share/common/BounceSpinner";
export default {
    name: "MediaLibrarySpinner",
    components: {BounceSpinner}
}
</script>
